import React, { FunctionComponent } from 'react'
import styles from './styles/avatar.module.scss'
import { Image } from 'react-bootstrap'
import classNames from 'classnames'
import { ReactComponent as NoAvatar } from 'images/avatars/default/no-avatar.svg'

interface Props {
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg'
  url?: string
  sizeInPx?: number
  fallback?: FunctionComponent
  classWrapper?: string
}

const Avatar = ({ size = 'sm', url, sizeInPx, fallback, classWrapper = '' }: Props) => {
  const style = sizeInPx
    ? {
        width: `${sizeInPx}px`,
        maxWidth: `${sizeInPx}px`,
        height: `${sizeInPx}px`,
        maxHeight: `${sizeInPx}px`,
      }
    : {}
  const AvatarFallback = fallback || NoAvatar

  return (
    <div className={classNames(styles.avatarImgWrapper, styles[size], classWrapper)} style={style}>
      {url ? (
        <Image src={url} alt='avatar' className={styles.avatar} />
      ) : (
        <AvatarFallback className={styles.avatar} />
      )}
    </div>
  )
}

export default Avatar
